export default "__VITE_ASSET__CNNY5kdK__"